import {VariantConfigT} from '@/lib/types/colors.types';

export const secondaryConfig: VariantConfigT = {
  basic: {
    icon: 'secondary',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'secondary',
    active: 'secondary',
  },
  outline: {
    icon: 'secondary',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
  ghost: {
    icon: 'secondary',
    iconHover: 'secondary',
    iconActive: 'secondary',
    hover: 'secondary',
    active: 'secondary',
  },
  gradient: {
    icon: 'white',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
  solid: {
    icon: 'white',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
};
